/** @format */

import Adminprofile from "../pages/Admin Profile/Adminprofile.jsx";
import AddNewBanner from "../pages/Banner Management/AddNewBanner.jsx";
import BannerManagement from "../pages/Banner Management/BannerManagement.jsx";
import EditBanner from "../pages/Banner Management/EditBanner.jsx";
import Chats from "../pages/Chats/Chats.jsx";
import Dashboard from "../pages/Dashboard/Dashboard.jsx";
import AddNewFAQ from "../pages/FAQ’s/AddNewFAQ.jsx";
import EditFAQ from "../pages/FAQ’s/EditFAQ.jsx";
import FAQ from "../pages/FAQ’s/FAQ.jsx";
// import AddJobCategory from "../pages/User Management/AddJobCategory.jsx";
// import EditJobCategory from "../pages/User Management/EditJobCategory.jsx";
// import ViewJobs from "../pages/User Management/ViewJobs.js";
import Login from "../pages/Login/Login.jsx";
import AssignJob from "../pages/Orders/AssignJob.jsx";
import Orders from "../pages/Orders/Orders.jsx";
import Payments from "../pages/Payments/Payments.jsx";
import EditPrivacyPolicy from "../pages/Privacy Policy/EditPrivacyPolicy.jsx";
import PrivacyPolicy from "../pages/Privacy Policy/PrivacyPolicy.jsx";
import EditTermsConditions from "../pages/Terms & Conditions/EditTermsConditions.jsx";
import TermsConditions from "../pages/Terms & Conditions/TermsConditions.jsx";
import AddTimesheet from "../pages/Timesheet Management/AddTimesheet.jsx";
import EditTimesheet from "../pages/Timesheet Management/EditTimesheet.jsx";
import TimesheetManagement from "../pages/Timesheet Management/TimesheetManagement.jsx";
import StaffPenalty from "../pages/Staff Penalty/StaffPenalty.jsx";
import ViewTimesheet from "../pages/Timesheet Management/ViewTimesheet.jsx";
import AddVouchersOffers from "../pages/Voucher & Offers/AddVouchersOffers.jsx";
import EditVouchersOffers from "../pages/Voucher & Offers/EditVouchersOffers.jsx";
import VoucherOffers from "../pages/Voucher & Offers/VoucherOffers.jsx";
import AddFunds from "../pages/Wallet Management/AddFunds.jsx";
import EditWallet from "../pages/Wallet Management/EditWallet.jsx";


import Category from "../pages/Job Management/Category.jsx";
import SubCategory from "../pages/Job Management/SubCategory.jsx";
import SubCategoryChild from "../pages/Job Management/SubCategoryChild.jsx";
import Products from "../pages/Job Management/Products.jsx";
import ActiveEmployee from "../pages/User Management/ActiveEmployee.jsx";
import Registered from "../pages/User Management/Registered.jsx";
import StaffLedger from "../pages/User Management/StaffLedger.jsx";
import TrackEmployee from "../pages/User Management/TrackEmployee.jsx";
import CreatePassword from "../pages/User Management/CreatePassword.jsx";
import AddPrivacyPolicy from "../pages/Privacy Policy/AddPrivacyPolicy.jsx";
import AddTermsConditions from "../pages/Terms & Conditions/AddTermsConditions.jsx";
import CancelPolicy from "../pages/Cancel Policy/CancelPolicy.jsx";
import AddCancelPolicy from "../pages/Cancel Policy/AddCancelPolicy.jsx";
import ContactDetailsOffice from "../pages/Contact Details/ContactDetailsOffice.jsx";
import AddContactDetailsOffice from "../pages/Contact Details/AddContactDetailsOffice.jsx";
import EditContactDetailsOffice from "../pages/Contact Details/EditContactDetailsOffice.jsx";
import Setting from "../pages/Setting/Setting.jsx";
import SettingForStaff from "../pages/Setting/SettingForStaff.jsx";
import TrainingVideo from "../pages/Training Video/TrainingVideo.jsx";
import SendNotifications from "../pages/Send Notifications/SendNotifications.jsx";
import AllNotifications from "../pages/Send Notifications/AllNotifications.jsx";
// import JobDetails from "../pages/User Management/JobDetails.jsx";
import AddStaff from "../pages/User Management/AddStaff.jsx";
import EditStaff from "../pages/User Management/EditStaff.jsx";
import StaffProfile from "../pages/User Management/StaffProfile.jsx";
import PaymentsDetails from "../pages/Payments/PaymentsDetails.jsx";
import EditCancelPolicy from "../pages/Cancel Policy/EditCancelPolicy.jsx";
import AllUser from "../pages/AllUser/AllUser.jsx";
import UserProfile from "../pages/AllUser/UserProfile.jsx";
import CreateOrder from "../pages/AllUser/CreateOrder.jsx";
import UserCart from "../pages/AllUser/UserCart.jsx";
import UserOrders from "../pages/AllUser/UserOrders.jsx";
import OrderDetails from "../pages/Orders/OrderDetails.jsx";
import StaffChats from "../pages/Chats/StaffChats.jsx";
import Outfit from "../pages/Outfit/Outfit.jsx";
import ReOrder from "../pages/AllUser/ReOrder.jsx";
import UserWalletManagement from "../pages/Wallet Management/UserWalletManagement.jsx";
import StaffWalletManagement from "../pages/Wallet Management/StaffWalletManagement.jsx";
import UserContactDetails from "../pages/Contact Details/UserContactDetails.jsx";
import StaffContactDetails from "../pages/Contact Details/StaffContactDetails.jsx";
import CreateProductOrder from "../pages/AllUser/CreateProductOrder.jsx";
import ForgetPassword from "../pages/Login/ForgetPassword.jsx";
import SubAdmin from "../pages/Sub Admin/SubAdmin.jsx";
import AddSubAdmin from "../pages/Sub Admin/AddSubAdmin.jsx";
import WithdrawalWindow from "../pages/Withdrawal Window/WithdrawalWindow.jsx";
import ManualPayouts from "../pages/Manual Payouts/ManualPayouts.jsx";


const allRoutes = [
  {
    route: "/",
    component: <Login />,
  },
  {
    route: "/dashboard",
    component: <Dashboard />,
  },
  // {
  //   route: "/job-management/add-jobcategory",
  //   component: <AddJobCategory />,
  // },
  {
    route: "/job-management/category",
    component: <Category />,
  },
  {
    route: "/job-management/subCategory",
    component: <SubCategory />,
  },
  {
    route: "/job-management/subcategory-Child",
    component: <SubCategoryChild />,
  },
  {
    route: "/job-management/products",
    component: <Products />,
  },


  {
    route: "/staff-management/registered",
    component: <Registered />,
  },
  {
    route: "/staff-management/active-employee",
    component: <ActiveEmployee />,
  },
  {
    route: "/staff-management/track-employee",
    component: <TrackEmployee />,
  },


  {
    route: "/staff-management/registered/createuser-id&Password/:id",
    component: <CreatePassword />,
  },


  {
    route: "/orders",
    component: <Orders />,
  },
  {
    route: "/orders/details/:id",
    component: <OrderDetails />,
  },
  {
    route: "/voucher-Offers",
    component: <VoucherOffers />,
  },
  {
    route: "/banner-Management",
    component: <BannerManagement />,
  },
  {
    route: "/wallet-management/user",
    component: <UserWalletManagement />,
  },
  {
    route: "/wallet-management/staff",
    component: <StaffWalletManagement />,
  },
  // {
  //   route: "/job-management/view-jobs",
  //   component: <ViewJobs />,
  // },
  {
    route: "/FAQ",
    component: <FAQ />,
  },
  {
    route: "/payments",
    component: <Payments />,
  },
  {
    route: "/timesheet-Management",
    component: <TimesheetManagement />,
  },
  {
    route: "/staff-penalty",
    component: <StaffPenalty />,
  },

  {
    route: "/staff-management/registered/staffprofile/:id",
    component: <StaffProfile />,
  },
  {
    route: "/staff-management/registered/staff-ledger/:id",
    component: <StaffLedger />,
  },

  {
    route: "/orders/assignjob/:id",
    component: <AssignJob />,
  },

  {
    route: "/voucher-Offers/add",
    component: <AddVouchersOffers />,
  },
  {
    route: "/voucher-Offers/edit/:id",
    component: <EditVouchersOffers />,
  },
  {
    route: "/banner-Management/add",
    component: <AddNewBanner />,
  },
  {
    route: "/banner-Management/edit/:id",
    component: <EditBanner />,
  },
  {
    route: "/wallet-management/addfunds",
    component: <AddFunds />,
  },
  {
    route: "/editwallet",
    component: <EditWallet />,
  },
  {
    route: "/FAQ/add",
    component: <AddNewFAQ />,
  },
  {
    route: "/FAQ/edit/:id",
    component: <EditFAQ />,
  },
  {
    route: "/addtimesheet",
    component: <AddTimesheet />,
  },
  {
    route: "/timesheet-Management/edit/:id",
    component: <EditTimesheet />,
  },
  {
    route: "/timesheet-Management/view/:id",
    component: <ViewTimesheet />,
  },
  {
    route: "/adminprofile",
    component: <Adminprofile />,
  },
  {
    route: "/staff-management/registered/addstaff",
    component: <AddStaff />,
  },
  {
    route: "/staff-management/registered/editstaff/:id",
    component: <EditStaff />,
  },
  {
    route: "/privacypolicy",
    component: <PrivacyPolicy />,
  },
  {
    route: "/privacypolicy/add",
    component: <AddPrivacyPolicy />,
  },
  {
    route: "/privacypolicy/edit/:id",
    component: <EditPrivacyPolicy />,
  },
  {
    route: "/termsconditions",
    component: <TermsConditions />,
  },
  {
    route: "/termsconditions/add",
    component: <AddTermsConditions />,
  },
  {
    route: "/termsconditions/edit/:id",
    component: <EditTermsConditions />,
  },
  {
    route: "/cancelpolicy",
    component: <CancelPolicy />,
  },
  {
    route: "/cancelpolicy/add",
    component: <AddCancelPolicy />,
  },
  {
    route: "/cancelpolicy/edit/:id",
    component: <EditCancelPolicy />,
  },
  {
    route: "/chats/user",
    component: <Chats />,
  },
  {
    route: "/chats/staff",
    component: <StaffChats />,
  },
  {
    route: "/contact-details/user",
    component: <UserContactDetails />,
  },
  {
    route: "/contact-details/staff",
    component: <StaffContactDetails />,
  },
  {
    route: "/contact-details/office",
    component: <ContactDetailsOffice />,
  },
  {
    route: "/contact-details/office/add",
    component: <AddContactDetailsOffice />,
  },
  {
    route: "/contact-details/office/edit/:id",
    component: <EditContactDetailsOffice />,
  },
  {
    route: "/setting/commission/user",
    component: <Setting />,
  },
  {
    route: "/setting/commission/staff",
    component: <SettingForStaff />,
  },
  {
    route: "/training-videos",
    component: <TrainingVideo />,
  },
  {
    route: "/notification/send",
    component: <SendNotifications />,
  },
  {
    route: "/notification/all",
    component: <AllNotifications />,
  },
  {
    route: "/user-management",
    component: <AllUser />,
  },
  {
    route: "/user-management/create-order/:id",
    component: <CreateOrder />,
  },
  {
    route: "/user-management/create-order/cart/:id",
    component: <UserCart />,
  },
  {
    route: "/user-management/user-orders/:id",
    component: <UserOrders />,
  },
  {
    route: "/user-management/userprofile/:id",
    component: <UserProfile />,
  },

  {
    route: "/payments/details/:id",
    component: <PaymentsDetails />,
  },

  {
    route: "/outfit",
    component: <Outfit />,
  },
  {
    route: "/user-management/user-orders/:userid/:id",
    component: <ReOrder />,
  },
  {
    route: "/user-management/create-product/:id",
    component: <CreateProductOrder />,
  },

   {
    route: "/forgot-password",
    component: <ForgetPassword />,
  },
  {
    route: "/sub-admin",
    component: <SubAdmin />,
  },
  {
    route: "/sub-admin/add",
    component: <AddSubAdmin />,
  },
  {
    route: "/withdrawal-window",
    component: <WithdrawalWindow />,
  },
  {
    route: "/manual-payouts",
    component: <ManualPayouts />,
  },
  // {
  //   route: "/edit-jobCategory",
  //   component: <EditJobCategory />,
  // },



];

export default allRoutes;